import React, { useEffect, useState } from "react";
import { Button, Form, Row, Space, message, Col, Spin, Popconfirm, Input } from "antd";
import { trans, SelectWithSearch, SelectResourceList, PaginationComponent } from "@comps/components"
import { createSelectList, createDepartmentListWithCode } from "@comps/commonFunctions";
import { makeRequestStateless } from "@utils/helpers";
import { filterEmploymentsReq } from "./requests";
import { ArrowRightOutlined, ArrowLeftOutlined, FilterOutlined, QuestionCircleOutlined, RightOutlined, LeftOutlined } from "@ant-design/icons";

import { Const } from "./constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { sharedTooltips } from "./tooltips/sharedTooltips";

const langKey = Const["restday"].lngKey

const fieldLabel = makeFieldLabel(sharedTooltips.employeeSelection, { namespace: "employeeSelection", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createRoaster";

const FilterSelectEmployees = (props) => {
  const isCreateRosterWizard = props.moduleName === 'companyRoaster';
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });

  const [locations, setlocations] = useState([]);
  const [branches, setbranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [grades, setgrades] = useState([]);
  const [designations, setdesignations] = useState([]);
  const [relatedData, setRelatedData] = useState([])
  const [locationBranches, setlocationBranches] = useState([]);
  const [initialSearchableList, setinitialSearchableList] = useState(props.initialEmployeesCriteria ? props.initialEmployeesCriteria : {});
  const [isSearching, setIsSearching] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState(props.previewEmployment ? createSelectList(props.previewEmployment) : []);
  const [selectedEmpForm] = Form.useForm();
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [form] = Form.useForm()
  const [filterForm] = Form.useForm()
  const [isRest, setIsRest] = useState(false)
  const [initialFilters, setInitialFilters] = useState(props.preFilters)
  const [loader, setLoader] = useState(false);
  const [availableSearch, setAvailableSearch] = useState("");
  const [selectedSearch, setSelectedSearch] = useState("");

  const getEmployeeName = (employee) => employee.full_name || employee.name || "Employee";
  const getEmployeeDesignation = (employee) => employee.designation_name || employee.designation || "";
  const getEmployeeInitials = (employee) => getEmployeeName(employee)
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();

  const uniqueEmployeesById = (employees) => {
    const employeeMap = new Map();
    (employees || []).forEach((employee) => {
      if (employee?.id !== undefined) {
        employeeMap.set(employee.id, employee);
      }
    });
    return Array.from(employeeMap.values());
  }

  const removeSelectedFromAvailable = (employees, selected) => {
    const selectedIds = new Set((selected || []).map((employee) => employee.id));
    return (employees || []).filter((employee) => !selectedIds.has(employee.id));
  }

  const employeeMatchesSearch = (employee, search) => {
    const normalizedSearch = search.trim().toLowerCase();
    if (!normalizedSearch) {
      return true;
    }

    return `${getEmployeeName(employee)} ${getEmployeeDesignation(employee)}`.toLowerCase().includes(normalizedSearch);
  }

  const availableEmployees = filteredEmployees.filter((employee) => employeeMatchesSearch(employee, availableSearch));
  const chosenEmployees = selectedEmployees.filter((employee) => employeeMatchesSearch(employee, selectedSearch));

  const moveEmployeeToSelected = (employeeToMove) => {
    setFilteredEmployees((prevEmployees) => prevEmployees.filter((employee) => employee.id !== employeeToMove.id));
    setSelectedEmployees((prevSelectedEmployees) => uniqueEmployeesById([...prevSelectedEmployees, employeeToMove]));
  };

  const moveEmployeeToUnSelected = (employeeToMove) => {
    setSelectedEmployees((prevEmployees) => prevEmployees.filter((employee) => employee.id !== employeeToMove.id));
    setFilteredEmployees((prevfilteredEmployees) => uniqueEmployeesById([...prevfilteredEmployees, employeeToMove]));
  };

  const moveAllToSelected = () => {
    setSelectedEmployees((prevSelectedEmployees) => uniqueEmployeesById([
      ...prevSelectedEmployees,
      ...filteredEmployees,
    ]));
    setFilteredEmployees([]);
    setPagination(null);
  };

  const moveAllToUnSelected = () => {
    setFilteredEmployees((prevfilteredEmployees) => uniqueEmployeesById([
      ...prevfilteredEmployees,
      ...selectedEmployees,
    ]));
    setSelectedEmployees([]);
  };



  useEffect(() => {
    ongetRelatedData(props.companyRelatedData)
    setData();
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    //onApplyFilter(props.preFilters);
    // eslint-disable-next-line
  }, [currentPage]);
  const setData = () => {
    const nextSelectedEmployees = selectedEmployees.length > 0 ? selectedEmployees : (props.selected || []);
    selectedEmpForm.setFieldsValue(
      {
        employment_ids: props.employment_ids
      }
    )
    setFilteredEmployees(removeSelectedFromAvailable(props.unSelected, nextSelectedEmployees))
    setSelectedEmployees(uniqueEmployeesById(nextSelectedEmployees))
  }

  const ongetRelatedData = (response) => {
    if (response) {
      setRelatedData(response);
      const locationsSource = response.locations || {};
      const locationsArray = Object.values(locationsSource);
      setlocationBranches(locationsSource)
      setlocations(createSelectList(locationsArray))
      setdesignations(createSelectList(response.designations || []));
      setgrades(createSelectList(response.grades || []));
      setDepartments(createDepartmentListWithCode(response.departments || []));
      const location_id = initialSearchableList ? initialSearchableList.location_id : null;
      //default branch
      for (const key in locationsSource) {
        if (locationsSource[key].id === location_id) {
          setbranches(createSelectList(locationsSource[key].branches || []));
        }
      }
    }
  }

  const onChangeLocation = (id) => {

    if (id) {
      for (const key in locationBranches) {
        if (locationBranches[key].id === id) {
          setbranches(createSelectList(locationBranches[key].branches));
        }
      }
    }
    else {
      setbranches([])
    }
  }

  const onApplyFilter = (data) => {
    props.setPrefilters(data)
    setIsSearching(true)
    setinitialSearchableList(data);
    let filters = `privilege_|false;department_h_code_|${data.department_id};employment_id_|${data.employment_id};location_id_|${data.location_id};branch_id_|${data.branch_id};designation_id_|${data.designation_id};grade_id_|${data.grade_id}`;
    let payload = { page: currentPage, filters: filters };
    makeRequestStateless(filterEmploymentsReq, payload, onfilteredEmployment, null);
  }

  const onfilteredEmployment = (response) => {
    setIsSearching(false)
    if (response.employee_employments.data.length === 0) {
      message.info('Employees Not Found');
      //setSelectedEmployees([])
      setFilteredEmployees([])
      return
    }
    message.success('Retrieved Successfully');

    setFilteredEmployees(removeSelectedFromAvailable(response.employee_employments.data, selectedEmployees))
    setPagination(response.employee_employments.meta.pagination)
    //setSelectedEmployees([])
  }

  const onSubmitEmployments = () => {
    if (selectedEmployees.length === 0) {
      message.error('Please select at least one employee.');
      return;
    }
    let empIds = []
    let selectedEmpData = [];
    selectedEmployees.forEach(each => {
      empIds.push(each.id);
      selectedEmpData.push(each);
    })
    const payload = {
      employment_ids: empIds
    }
    setSelectedEmployees(selectedEmpData);

    props.setSelectedEmploymentsIds(payload)
    props.setUnselected(filteredEmployees)
    props.setSelected(selectedEmployees)
    setLoader(true);
  }

  const onResetFilter = () => {
    filterForm.resetFields()
    filterForm.setFieldsValue({})
    filterForm.setFieldValue('employment_id', null)
    //setFilteredEmployees([])
    //setSelectedEmployees([])
    setIsRest(!isRest)
    setInitialFilters({})
  }

  const renderEmployee = (employee, direction) => (
    <li key={ employee.id }>
      <button
        type="button"
        onClick={ () => direction === "selected" ? moveEmployeeToSelected(employee) : moveEmployeeToUnSelected(employee) }
        className="moveEmployee create-roster-employee-card"
      >
        <span className="create-roster-employee-avatar">{ getEmployeeInitials(employee) }</span>
        <span className="create-roster-employee-meta">
          <span className="each-full-name">{ getEmployeeName(employee) }</span>
          <span className="each-designation-name">{ getEmployeeDesignation(employee) }</span>
        </span>
        <span className="create-roster-row-action">
          { direction === "selected" ? <RightOutlined /> : <LeftOutlined /> }
        </span>
      </button>
    </li>
  )

  const renderLegacyEmployee = (employee, direction) => (
    <Space key={ employee.id }>
      <li key={ employee.id }>
        <div onClick={ () => direction === "selected" ? moveEmployeeToSelected(employee) : moveEmployeeToUnSelected(employee) } className="moveEmployee">
          <div>
            <div><img className="each-profile-pic-thumb-url" src={ employee.profile_pic_thumb_url !== "images/arnold-avatar.jpg" ? employee.profile_pic_thumb_url : "/images/arnold-avatar.jpg" } alt="" /></div>
            <div className="each-employee"> <p className="each-full-name">{ employee.full_name }</p>
              <p className="each-designation-name">{ employee.designation_name }</p>
            </div>
          </div>
        </div>
      </li>
    </Space>
  )

  return (
    <>
      <div className={ isCreateRosterWizard ? "create-roster-filter-card" : "" } style={ { paddingTop: 25, paddingLeft: 20, paddingRight: 20, border: "1px solid #C9D6DF", borderRadius: 10, background: 'rgba(201, 214, 223, 0.05)' } }>
        { isCreateRosterWizard ?
          <div className="create-roster-filter-card-header">
            <div className="create-roster-filter-card-title">
              <FilterOutlined />
              <span>Filters</span>
              <QuestionCircleOutlined />
            </div>
          </div>
          : null }

        <Form
          { ...formLayout }
          name={ formName }
          onFinish={ onApplyFilter }
          initialValues={ initialFilters }
          form={ filterForm }
          scrollToFirstError
        >
          <Row gutter={ 20 }>
            <Col lg={ 8 } sm={ 12 } xs={ 24 }>
              <Form.Item name="employment_id" rules={ [] } label={ fieldLabel("employment_id", trans(`${langKey}.employment_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectResourceList type='employment' mode="multiple" />
              </Form.Item>
            </Col>

            <Col lg={ 8 } sm={ 12 } xs={ 24 }>
              <Form.Item name="location_id" rules={ [] } label={ fieldLabel("location_id", trans(`${langKey}.location_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ "Select Location" }
                  onChange={ onChangeLocation }
                  options={ locations }
                />
              </Form.Item>
            </Col>

            <Col lg={ 8 } sm={ 12 } xs={ 24 } >
              <Form.Item name="designation_id" rules={ [] } label={ fieldLabel("designation_id", trans(`${langKey}.designation_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ "Select Designation" }
                  options={ designations }
                />
              </Form.Item>
            </Col>

            <Col lg={ 8 } sm={ 12 } xs={ 24 }>
              <Form.Item name="grade_id" rules={ [] } label={ fieldLabel("grade_id", trans(`${langKey}.grade_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ "Select Grade" }
                  options={ grades }
                />
              </Form.Item>
            </Col>

            <Col lg={ 8 } sm={ 12 } xs={ 24 }>
              <Form.Item name="department_id" rules={ [] } label={ fieldLabel("department_id", trans(`${langKey}.department_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ "Select Department" }
                  options={ departments }
                />
              </Form.Item>
            </Col>

            <Col lg={ 8 } sm={ 12 } xs={ 24 }>
              <Form.Item name="branch_id" rules={ [] } label={ fieldLabel("branch_id", trans(`${langKey}.branch_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ "Select Branch" }
                  options={ branches }
                />
              </Form.Item>
            </Col>
          </Row>


          <div className="button-style-filter">

            <Button className="button-applyFilter" type="primary" disabled={ false } htmlType="submit" loading={ isSearching }>Apply Filter</Button>
            <Button onClick={ onResetFilter } form={ formName } htmlType="button" className="button-applyFilter" type="primary" disabled={ false } danger>Reset Filter</Button>
          </div>
        </Form>
      </div>

      <Form onFinish={ onSubmitEmployments } initialValues={ setSelectedEmployees } id="filterEmployeeForm" name="filterEmployeeForm" form={ form }>
        <Spin spinning={ isSearching } tip="Loading...">
          { isCreateRosterWizard ?
            <Row gutter={ 16 } className="create-roster-transfer-row">
              <Col lg={ 11 } sm={ 24 } xs={ 24 }>
                <div className="unselected-employees-style">
                  <div className="unselected-employees">
                    <h5 className="unselected-employees-text">Available</h5>
                    <span className="create-roster-panel-count">{ filteredEmployees.length }</span>
                  </div>
                  <div className="create-roster-list-search">
                    <Input placeholder="Search..." value={ availableSearch } onChange={ (event) => setAvailableSearch(event.target.value) } />
                  </div>
                  <div className="create-roster-list-scroll">
                    { availableEmployees.map((each) => renderEmployee(each, "selected")) }
                  </div>
                </div>
                {/* <PaginationComponent pagination={ pagination } setCurrentPage={ onChangePagination } currentPage={ currentPage } numbering={false} /> */ }
              </Col>

              <Col lg={ 2 } sm={ 24 } xs={ 24 } className="create-roster-transfer-controls">
                <Button className="unselected-employees-button" onClick={ moveAllToSelected }>
                  <ArrowRightOutlined style={ { fontSize: 16 } } />
                </Button>
                <Button className="unselected-employees-button1" onClick={ moveAllToUnSelected }>
                  <ArrowLeftOutlined style={ { fontSize: 16 } } />
                </Button>
              </Col>

              <Col lg={ 11 } sm={ 24 } xs={ 24 }>
                <div className="unselected-employees-style1">
                  <div className="unselected-employees">
                    <h5 className="unselected-employees-text">Selected</h5>
                    <span className="create-roster-panel-count">{ selectedEmployees.length }</span>
                  </div>
                  <div className="create-roster-list-search">
                    <Input placeholder="Search..." value={ selectedSearch } onChange={ (event) => setSelectedSearch(event.target.value) } />
                  </div>
                  <div className="create-roster-list-scroll">
                    { chosenEmployees.map((each) => renderEmployee(each, "unselected")) }
                  </div>
                </div>
              </Col>
            </Row>
            : <Row gutter={ 30 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <div className="unselected-employees-style">
                  <div className="unselected-employees">
                    <h5 className="unselected-employees-text">Unselected Employees { filteredEmployees.length > 0 ? `(${filteredEmployees.length})` : '' }</h5>
                  </div>
                  <Button className="unselected-employees-button" onClick={ moveAllToSelected }>
                    <ArrowRightOutlined style={ { fontSize: 16 } } />
                  </Button>
                  { filteredEmployees.map((each) => renderLegacyEmployee(each, "selected")) }
                </div>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <div className="unselected-employees-style1">
                  <div className="unselected-employees">
                    <h5 className="unselected-employees-text">Selected Employees { selectedEmployees.length > 0 ? `(${selectedEmployees.length})` : '' }</h5>
                  </div>
                  <Button className="unselected-employees-button1" onClick={ moveAllToUnSelected }>
                    <ArrowLeftOutlined style={ { fontSize: 16 } } />
                  </Button>
                  { selectedEmployees.map((each) => renderLegacyEmployee(each, "unselected")) }
                </div>
              </Col>
            </Row> }

        </Spin>

        { props.hideFooter ? null : <div className="button-style">
          { props.is_delete ? <Popconfirm
            title="Delete"
            description="Are you sure to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={ onSubmitEmployments }
          >
            <Button disabled={ selectedEmployees.length === 0 } className="button-next" loading={ loader } style={ { background: props.is_delete ? "#EA4335" : "#4079FC" } } type="primary">
              { props.is_delete ? 'Delete' : 'Next' }
            </Button>
          </Popconfirm> :
            <Button disabled={ selectedEmployees.length === 0 } className="button-next" onClick={ onSubmitEmployments } loading={ props.saveButton ? false : loader } style={ { background: props.is_delete ? "#EA4335" : "#4079FC" } } type="primary">
              { props.is_delete ? 'Delete' : props.saveButton ? "Save" : 'Next' }
            </Button>
          }


          <Button className="button-back" onClick={ () => props.onBack() }>
            <span style={ { color: "#4079FC" } }>Back</span>
          </Button>
        </div> }
      </Form>

    </>
  )
}

export default FilterSelectEmployees
const rules = {
  employment_ids: [
    { required: true, message: 'Please select employee' },
  ],
  end_date: [
    { required: true, message: 'Please select end date' },
  ],
  repeat: [
    { required: true, message: 'Please enter repeat' },
  ],
  font_colour: [
    { required: true, message: 'Please enter font colour' },
  ],
  bg_colour: [
    { required: true, message: 'Please enter bg colour' },
  ],

};
const formLayout = {
  layout: "vertical",
  labelCol: { span: 2 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
